

export const index = 1;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/fallbacks/error.svelte.js')).default;
export const imports = ["_app/immutable/nodes/1.71323be8.js","_app/immutable/chunks/scheduler.2cb4bb00.js","_app/immutable/chunks/index.7d06ba6e.js","_app/immutable/chunks/stores.157462ce.js","_app/immutable/chunks/singletons.cf5ac3e4.js"];
export const stylesheets = [];
export const fonts = [];
